import { useLocation, useParams } from 'react-router-dom';

import type { CreatedOrder } from '../lib/api';
import { money } from '../lib/i18n';
import { useSeo } from '../lib/head';
import { Link } from '../lib/router';
import { privateMeta } from '../lib/seo';
import { useStore } from '../lib/store';

/**
 * Страница «заказ принят».
 *
 * Данные заказа приходят из состояния перехода — запрашивать их заново
 * незачем, мы только что их получили. При перезагрузке страницы состояние
 * теряется, и остаётся номер: этого достаточно, чтобы человек не потерялся.
 */
export function OrderDone() {
  const { number = '' } = useParams();
  const { state } = useLocation() as {
    state: (CreatedOrder & { deliveryQuotedSeparately?: boolean }) | null;
  };
  const { lang, t } = useStore();
  useSeo(privateMeta(lang, 'orderTitle'));

  return (
    <div className="wrap page" style={{ maxWidth: '36rem', textAlign: 'center' }}>
      <span className="hand" style={{ fontSize: '1.5rem' }}>
        {t.thanks}
      </span>
      <h1 style={{ marginTop: '0.5rem' }}>{t.orderPlaced}</h1>

      <p className="lede" style={{ margin: '0 auto 2rem' }}>
        {t.orderNumber} <b>{number}</b>
        {state && (
          <>
            {' · '}
            {money(state.total, state.currency, lang)}
            {state.deliveryQuotedSeparately && `\u00a0${t.plusDelivery}`}
          </>
        )}
      </p>

      <div className="panel" style={{ textAlign: 'left' }}>
        <h2>{t.whatNext}</h2>
        <p style={{ margin: 0 }}>{t.whatNextText}</p>
      </div>

      <Link to="/" className="btn btn--ghost" style={{ marginTop: '2rem' }}>
        {t.backHome}
      </Link>
    </div>
  );
}
